import { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import HeaderSticky from "./HeaderSticky";
import ResponsiveMenu from "./ResponsiveMenu";

const HeaderTwo = ({
  styles,
  disableSticky,
  searchDisable,
  buttonStyle,
  handleScroll,
}) => {
  const [offcanvasShow, setOffcanvasShow] = useState(false);
  const [searchPopup, setSearchPopup] = useState(false);
  const onCanvasHandler = () => {
    setOffcanvasShow((prevState) => !prevState);
  };

  const onSearchHandler = () => {
    setSearchPopup((prevState) => !prevState);
  };

  if (searchPopup) {
    document.body.classList.add("search-popup-active");
  } else {
    document.body.classList.remove("search-popup-active");
  }

  const sticky = HeaderSticky(200);
  const classes = `header-default ${sticky ? "sticky" : ""}`;
  const stickyStatus = disableSticky ? "" : " header-sticky";
  return (
    <>
      <header
        className={`edu-header ${stickyStatus} ${styles || ""} ${
          classes || ""
        }`}
      >
        <div className="row align-items-center">
          <div className="col-lg-3 col-xl-3 col-md-6 col-6">
            <div className="logo">
              <Link to={"/"}>
                {/* <img className="logo-light" src={`${process.env.PUBLIC_URL}/images/logo/logo.png`} alt="Main Logo" /> */}
                <img
                  className="logo-light"
                  src={`${process.env.PUBLIC_URL}/images/logo/adminLogo5.png`}
                  alt="Main Logo"
                />
                <div className="name">
                  PROMPT'S INSTITUTE OF BUSINESS ACCOUNTING & TAXATION
                </div>
              </Link>
            </div>
          </div>

          <div className="col-lg-7 d-none d-xl-block">
            <nav className="mainmenu-nav d-none d-lg-block">
              <Nav handleScroll={handleScroll} />
            </nav>
          </div>

          <div className="col-lg-2 col-xl-2 col-md-6 col-6">
            <div className="header-right d-flex justify-content-end">
              <div className="header-menu-bar">
                <div className="quote-icon quote-user d-none d-md-block ml--15 ml_sm--5">
                  <button
                    className={`edu-btn btn-medium left-icon header-button ${
                      buttonStyle || ""
                    }`}
                    style={{ marginRight: 15 }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = process.env.REACT_APP_STUDENT_URL;
                    }}
                  >
                    <i className="ri-user-line"></i>Student Login
                  </button>
                </div>
              </div>
              <div className="mobile-menu-bar ml--15 ml_sm--5 d-block d-xl-none">
                <div className="hamberger">
                  <button
                    className="white-box-icon hamberger-button header-menu"
                    onClick={onCanvasHandler}
                  >
                    <i className="ri-menu-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ResponsiveMenu
        show={offcanvasShow}
        onClose={onCanvasHandler}
        showSearch={searchPopup}
        onSearch={onSearchHandler}
      />
    </>
  );
};

export default HeaderTwo;
